( function( $ ) {

    $('document').ready(function(){
        // Burger nav
        $('.menu-toggle').on('click', function(){
            $('header').toggleClass('header--menu-is-open');
            $('.main-navigation').toggleClass('menu-is-open');
        });
    });

    let lastScrollY = window.scrollY;
    const header = document.querySelector('header');

    // Créé et injecté directement dans body pour éviter les problèmes de overflow
    const backTop = document.createElement('button');
    backTop.className = 'back-top';
    backTop.setAttribute('aria-label', 'Retour en haut de page');
    backTop.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    document.body.appendChild(backTop);

    window.addEventListener('scroll', function() {
        const currentScrollY = window.scrollY;

        if (currentScrollY <= 0) {
            header.classList.remove('header--hidden', 'header--scrolled');
        } else if (currentScrollY < lastScrollY) {
            header.classList.remove('header--hidden');
            header.classList.add('header--scrolled');
        } else if (currentScrollY > lastScrollY && currentScrollY > 80) {
            header.classList.add('header--hidden');
        }

        if (backTop) {
            if (currentScrollY > window.innerHeight * 1.2) {
                backTop.classList.add('is-visible');
            } else {
                backTop.classList.remove('is-visible');
            }
        }

        lastScrollY = currentScrollY;
    }, { passive: true });

    if (backTop) {
        backTop.addEventListener('click', function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // ─── Hero accueil : déplace description + actions hors de __content sur mobile
    if (window.matchMedia('(max-width: 960px)').matches) {
        const grid    = document.querySelector('.hero-accueil__grid');
        const desc    = document.querySelector('.hero-accueil__description');
        const actions = document.querySelector('.hero-accueil__actions');
        if (grid && desc)    grid.appendChild(desc);
        if (grid && actions) grid.appendChild(actions);
    }

    // ─── Animations GSAP ScrollTrigger ────────────────────────────────────────
    gsap.registerPlugin(ScrollTrigger);

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

        const trigger = { start: 'top 88%', end: 'bottom 10%', toggleActions: 'play none none reverse' };

        // Titres principaux — fade + montée
        document.querySelectorAll([
            '.fondations__titre',
            '.bio-longue__titre',
            '.convictions h2',
            '.constat__titre',
            '.cta-final__titre',
            '.rdv-form h2',
            '.hero-accueil__titre',
            '.hero-accueil__titre-italic',
            '.mon-parcours__col h2',
            '.offres__titre',
            '.qui-je-suis h2',
            '.etapes__intro h2',
            '.clarte-reassurance__titre',
            '.section-numero',
        ].join(', ')).forEach(el => {
            gsap.from(el, {
                opacity: 0, y: 40, duration: 0.85, ease: 'power2.out',
                scrollTrigger: { trigger: el, ...trigger },
            });
        });

        // Eyebrows — fade + letter-spacing qui s'ouvre
        document.querySelectorAll('.eyebrow, .fondations__eyebrow, .etapes__eyebrow').forEach(el => {
            gsap.from(el, {
                opacity: 0,
                letterSpacing: '0.4em',
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: { trigger: el, ...trigger },
            });
        });

        // Textes d'accompagnement — fade simple
        document.querySelectorAll([
            '.fondations__texte',
            '.constat__texte',
            '.convictions__texte',
            '.rdv-form__description',
            '.hero-accueil__description',
            '.clarte-reassurance__texte',
            '.mon-parcours__intro',
            '.mon-parcours__accroche',
        ].join(', ')).forEach(el => {
            gsap.from(el, {
                opacity: 0, duration: 0.7, ease: 'power1.out',
                scrollTrigger: { trigger: el, ...trigger },
            });
        });

        // Pills approche-fondations (stagger)
        const pills = document.querySelectorAll('.fondations__pills li');
        if (pills.length) {
            gsap.from(pills, {
                opacity: 0, y: 24, duration: 0.6, ease: 'power2.out',
                stagger: 0.08,
                scrollTrigger: { trigger: '.fondations__pills', ...trigger },
            });
        }

        // Items trois-étapes (stagger)
        const etapesItems = document.querySelectorAll('.etapes__item');
        if (etapesItems.length) {
            gsap.from(etapesItems, {
                opacity: 0, y: 20, duration: 0.55, ease: 'power2.out',
                stagger: 0.1,
                scrollTrigger: { trigger: '.etapes__liste', ...trigger },
            });
        }

        // Offres / cartes (stagger)
        const offresItems = document.querySelectorAll('.offres__item');
        if (offresItems.length) {
            gsap.from(offresItems, {
                opacity: 0, y: 32, duration: 0.7, ease: 'power2.out',
                stagger: 0.15,
                scrollTrigger: { trigger: '.offres__liste', ...trigger },
            });
        }

        // Services visibilité (stagger)
        const visItems = document.querySelectorAll('.services-visibilite__item');
        if (visItems.length) {
            gsap.from(visItems, {
                opacity: 0, y: 32, duration: 0.7, ease: 'power2.out',
                stagger: 0.15,
                scrollTrigger: { trigger: '.services-visibilite__grid', ...trigger },
            });
        }

        // Médias / images — mask reveal bas → haut
        document.querySelectorAll([
            '.qui-je-suis__media',
            '.constat__media',
            '.convictions__media',
            '.mon-parcours__media',
            '.hero-accueil__media',
        ].join(', ')).forEach(el => {
            gsap.from(el, {
                clipPath: 'inset(100% 0 0 0)',
                duration: 0.6,
                ease: 'power3.inOut',
                scrollTrigger: { trigger: el, ...trigger },
            });
        });

        // Mask reveal gauche → droite (classe .mask-reveal)
        document.querySelectorAll('.mask-reveal').forEach(el => {
            gsap.from(el, {
                clipPath: 'inset(0 100% 0 0)',
                duration: 1,
                ease: 'power3.inOut',
                scrollTrigger: { trigger: el, ...trigger },
            });
        });

        // Signature — mask reveal gauche → droite
        const signature = document.querySelector('.qui-je-suis__signature');
        if (signature) {
            gsap.from(signature, {
                clipPath: 'inset(0 100% 0 0)',
                duration: 1,
                ease: 'power3.inOut',
                scrollTrigger: { trigger: signature, start: 'top 90%', end: 'bottom 10%', toggleActions: 'play none none reverse' },
            });
        }

        // Boutons CTA
        document.querySelectorAll('.cta-final__actions .btn').forEach((el, i) => {
            gsap.from(el, {
                opacity: 0, y: 16, duration: 0.5, ease: 'power1.out',
                delay: i * 0.1,
                scrollTrigger: { trigger: '.cta-final__actions', ...trigger },
            });
        });

    }
    // ──────────────────────────────────────────────────────────────────────────

}( jQuery ) );
